import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
    resultRegistrationFlowFeatureKey,
    ResultRegistrationFlowState,
} from './result-registration-flow.reducer';

export const selectResultRegistrationFlowState = createFeatureSelector<ResultRegistrationFlowState>(
    resultRegistrationFlowFeatureKey,
);

export const selectResultRegistrationFlowActivity = createSelector(
    selectResultRegistrationFlowState,
    (state) => state.activity,
);

export const selectResultRegistrationFlowRegistrationData = createSelector(
    selectResultRegistrationFlowState,
    (state) => state.data,
);

export const selectResultRegistrationComponentState = createSelector(
    selectResultRegistrationFlowState,
    (state) => state.resultRegistrationComponentState,
);
